import { Modal, Header } from 'semantic-ui-react';

function History({ open }) {
	return (
		<Modal
			open={open}
			closeIcon
			size="mini"
		>
			<Header>Payment History</Header>

			<Modal.Content>

			</Modal.Content>
		</Modal>
	);
}

export default History;
